import src from "IMAGE";
export default { src, width: 178, height: 42, blurWidth: 0, blurHeight: 0};
